﻿<script>
    import { nanoid } from "nanoid";

    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import VinNumberInput from "./VinNumberInput.svelte";
    import TextInput from "./TextInput.svelte";
    import Select from "./Select.svelte";
    import YesNoGroup from "./YesNoGroup.svelte";
    import YesNoDontKnowGroup from "./YesNoDontKnowGroup.svelte";
    import RadioGroup from "./RadioGroup.svelte";
    import DatePicker from "./DatePicker.svelte";

    import lookups from '../stores/lookupStore';

    export let id = nanoid(6);
    export let vehicleDetail = [];
    export let disabled = null;

    const acquisitionIdDealer = $lookups.acquisition.filter(l => l.lookupName === "Purchased new or second hand through a dealer")[0].id;
    const acquisitionIdIndividual = $lookups.acquisition.filter(l => l.lookupName === "Purchased second hand through an individual")[0].id;
    const acquisitionIdLeased = $lookups.acquisition.filter(l => l.lookupName === "Leased the vehicle")[0].id;
    const acquisitionIdOnHire = $lookups.acquisition.filter(l => l.lookupName === "On hire purchase")[0].id;


    //$:{
    //    console.log("Vehicle", vehicleDetail, $lookups);
    //}

</script>

<FormRow class="mt-2">
    <FormColumn>
        <Select required
            {disabled}
            label="What is the make of your Toyota vehicle"
            sublabel="Please note that if your vehicle make does not appear in the list you are not eligible for the action"
            bind:value={vehicleDetail.vehicleMakeId}
            optionList={$lookups.vehicleMake}
            textProperty="lookupName"
			valueProperty="id">
        </Select>
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <VinNumberInput required=true
            {disabled}
            bind:value={vehicleDetail.vin}
        />
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <DatePicker required
            {disabled}
            label="When was your vehicle manufactured"
            sublabel="If you do not know the exact date, please select the first day of the month in that year"
            bind:formattedSelected={vehicleDetail.dateManufactured}
            start={new Date(2015, 9, 1)}
            end={new Date()}
            placeholder="01/10/2015"
        >
        </DatePicker>
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <RadioGroup required
            {disabled}
            name="howAquired_{id}"
            label="How did you acquire your vehicle?"
            sublabel="Please note that if you acquired your vehicle through an auction that vehicle will not be eligible for the action"
            bind:value={vehicleDetail.acquisitionId}
            optionList={$lookups.acquisition}
            labelProperty = "lookupName"
            valueProperty = "id"
            cols="12"
        >
        </RadioGroup>
    </FormColumn>
</FormRow>

{#if vehicleDetail.acquisitionId === acquisitionIdDealer}
    <FormRow>
        <FormColumn>
                <TextInput required
                    {disabled}
                    label="Name of dealer"
                    bind:value={vehicleDetail.dealerName}>
                </TextInput>
        </FormColumn>
    </FormRow>
{:else if vehicleDetail.acquisitionId === acquisitionIdIndividual}
    <FormRow>
        <FormColumn>
                <YesNoDontKnowGroup required
                    {disabled}
                    name="purchasedDirectlyFromToyota_{id}"
                    label="Did the person who sold you the vehicle purchase directly from a Toyota dealership?"
                    bind:value={vehicleDetail.hadDirectToyotaDealershipPurchase}>
                </YesNoDontKnowGroup>
        </FormColumn>
    </FormRow>
    {#if vehicleDetail.hadDirectToyotaDealershipPurchase==="No" || vehicleDetail.hadDirectToyotaDealershipPurchase==="Don't know"}
    <FormRow>
        <FormColumn>
            <div class="redText">
                Please note that if the person who sold you the vehicle did not buy the vehicle from a dealership, you will not be eligible for the action
            </div>
        </FormColumn>
    </FormRow>
    {/if}
{:else if vehicleDetail.acquisitionId === acquisitionIdLeased}
    <FormRow>
        <FormColumn>
                <TextInput required
                    {disabled}
                    label="Company who leased you the vehicle"
                    bind:value={vehicleDetail.leasingCompany}>
                </TextInput>
        </FormColumn>
    </FormRow>
{:else if vehicleDetail.acquisitionId === acquisitionIdOnHire}
    <FormRow>
        <FormColumn>
                <TextInput required
                    {disabled}
                    label="Company who provided the on-hire purchase"
                    bind:value={vehicleDetail.onHirePurchaseCompany}>
                </TextInput>
        </FormColumn>
    </FormRow>
{/if}



<FormRow>
    <FormColumn>
        <DatePicker required
            {disabled}
            label="What date did you acquire your vehicle?"
            bind:formattedSelected={vehicleDetail.dateAquired}
            start={new Date(2015, 9, 1)}
            end={new Date()}
            placeholder="01/10/2015"
        >
        </DatePicker>
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <YesNoGroup required
                {disabled}
                name="reSupplied_{id}"
                label="Did you purchase the vehicle for the purpose of re-supply?"
                bind:value={vehicleDetail.purchasedForReSupply}>
            </YesNoGroup>
    </FormColumn>
</FormRow>

<style>
    .redText{
        color: var(--color-primary);
        font-weight: bold;
    }
</style>